<template>
  <div id="report-container">
    <div id="reports-header">{{ $t('reports title') }}</div>
    <div v-for="error in errors">
      {{error.response.data.Message}}
    </div>
    <div id="reports">
      <router-link class="view-link" :to="{name: 'Frame',  query: { userId: userId, managerId: report.managerId }}" :key="report.managerId" v-for="report in reports">
        <div >{{report.title}}</div>
     </router-link>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    computed: {
      ...mapGetters({
        userId: 'user/userId',
        reports: 'user/reports',
        errors: 'user/errors'
      })
    },
    methods: {
      ...mapActions('user', [
        'loadReports'
      ])
    },
    mounted () {
      this.loadReports()
    }
  }
</script>

<style scoped>
  .view-link {
    display: block;
    text-decoration: none;
    color: black;
    padding: 10px;
    transition: background-color .5s;
  }

  .view-link:hover {
    background-color: #ddd;
  }
  #report-container{
    height:100%;
    overflow: auto;
  }
  #reports-header {
    padding: 20px;
    overflow: hidden;
    border: none;
    font: normal 25px/1 "Roboto", sans-serif;
    color: rgba(255,255,255,1);
    text-align: center;
    background: #18A7AA;
    text-shadow: 1px 1px 1px rgba(0,0,0,0.2) ;
  }
  #reports{
    margin-top: 15px;
  }
</style>
